import { TextField } from '@mui/material';

const AUTO_RENEW = { yes: true, no: false } as const;
const autoRenewValue = (autoRenew?: boolean | null) => (autoRenew == null ? '' : autoRenew ? 'yes' : 'no');

/** Auto-renew as Yes, No or Not set, saved as soon as it is picked. */
export const AutoRenewField = ({
  autoRenew,
  canEdit,
  onPick
}: {
  autoRenew?: boolean | null;
  canEdit: boolean;
  onPick: (autoRenew: boolean | null) => void;
}) => (
  <TextField
    select
    id="contract-auto_renew"
    label="Auto-renew"
    size="small"
    value={autoRenewValue(autoRenew)}
    disabled={!canEdit}
    InputLabelProps={{ shrink: true }}
    SelectProps={{ native: true }}
    onChange={(event) => {
      const picked = event.target.value as keyof typeof AUTO_RENEW | '';
      onPick(picked ? AUTO_RENEW[picked] : null);
    }}>
    <option value="">Not set</option>
    <option value="yes">Yes</option>
    <option value="no">No</option>
  </TextField>
);
